import React from "react";
import "containers/Account/Onboarding/Onboarding.css";
import AxiosConfig from "axiosConfig";
import TextTheme from "components/General/Text/TextTheme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faPlus } from "@fortawesome/free-solid-svg-icons";
import GuardianInfo from "./GuardianInfo";
import UnregisteredGuardianInfo from "./UnregisteredGuardianInfo";

import MyInvatations from "./MyInvatations";
class GuardianManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      relationship: "",
      errorMap: new Map(),
      pageError: "",
      guardians: [],
      unregisteredGuardians: [],
      invitations: [],
    };
  }

  componentDidMount() {
    this.fetchGuardianDetails(this);
    this.fetchUnregisteredGuardianDetails(this);
    this.getInvitations(this);
  }

  fetchGuardianDetails = function (obj) {
    AxiosConfig.get("guardian/get_guardians/").then((response) => {
      obj.setState({ guardians: response.data });
    });
  };

  fetchUnregisteredGuardianDetails = function (obj) {
    AxiosConfig.get("guardian/get_unregistered_guardians/").then((response) => {
      obj.setState({ unregisteredGuardians: response.data });
    });
  };

  getInvitations = function (obj) {
    AxiosConfig.get("guardian/get_invited_as_guardians/").then((response) => {
      obj.setState({ invitations: response.data });
    });
  };

  renderGuardians(guardian, keys, values) {
    const secGuardian = guardian.secondary_guardian;
    return (
      <GuardianInfo
        secGuardian={secGuardian}
        guardian={guardian}
        guardianName={secGuardian.user_name}
        guardianImage={secGuardian.user_photo}
        status={guardian.status}
        guardianEmail={secGuardian.user_email}
      />
    );
  }
  renderInvatations(guardian, keys, values) {
    const secGuardian = guardian.secondary_guardian;
    return (
      <MyInvatations
        secGuardian={secGuardian}
        guardian={guardian}
        guardianName={secGuardian.user_name}
        guardianImage={secGuardian.user_photo}
        status={guardian.status}
        guardianEmail={secGuardian.user_email}
      />
    );
  }

  renderUnregisteredGuardians(guardian) {
    return (
      <UnregisteredGuardianInfo guardian={guardian} status={guardian.status} />
    );
  }

  render() {
    return (
      <>
        <div>
          <TextTheme
            message="Family Accounts You're Invited To"
            className="text_bold"
            styles={{
              textAlign: "center",
              marginTop: "20px",
              fontSize: "20px",
              marginBottom: "20px",
            }}
          />
          {this.state.invitations.map((guardian) =>
            this.renderInvatations(
              guardian,
              Object.keys(guardian.secondary_guardian),
              Object.values(guardian.secondary_guardian)
            )
          )}
          <TextTheme
            message="Invite Guardians to Your Account"
            className="text_bold"
            styles={{
              textAlign: "center",
              marginTop: "20px",
              fontSize: "20px",
              marginBottom: "20px",
            }}
          />
          <TextTheme
            message="Registered Invited Guardians"
            styles={{
              textAlign: "center",
              marginTop: "10px",
              fontSize: "18px",
              marginBottom: "20px",
            }}
          />
          {this.state.guardians.map((guardian) =>
            this.renderGuardians(
              guardian,
              Object.keys(guardian.secondary_guardian),
              Object.values(guardian.secondary_guardian)
            )
          )}
          <TextTheme
            message="Unregistered Invited Guardians"
            styles={{
              textAlign: "center",
              marginTop: "10px",
              fontSize: "18px",
              marginBottom: "20px",
            }}
          />
          {this.state.unregisteredGuardians.map((guardian) =>
            this.renderUnregisteredGuardians(guardian.secondary_guardian_email)
          )}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button className="btn btn-sm" style={{ marginRight: "20px" }} />
          <button
            className="btn btn-sm"
            style={{
              display: "flex",
              backgroundColor: "#30AFC8",
              width: "auto",
              paddingTop: "10px",
              paddingBottom: "10px",
              marginBottom: "20px",
              borderRadius: 10,
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => {
              window.location.assign("/add-guardian");
            }}
          >
            <FontAwesomeIcon size="lg" icon={faPlus} color="white" />
            <TextTheme
              message="Add Guardian"
              styles={{
                color: "white",
                marginLeft: "10px",
                fontSize: "15px",
              }}
            />
          </button>
        </div>
      </>
    );
  }
}

export default GuardianManagement;
